import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { getIsPlaylistEditable } from 'utils/privileges';
import Stack from 'components/Stack';
import { HorizontalCard } from 'components/ContentCards';
import { useCardController } from 'components/ContentCards/controllers';
import { checkIsAsset } from 'types/content/utils';
import SectionBlock from './SectionBlock';
function ControlledHorizontalCard(_ref) {
  var data = _ref.data,
    _onWebAssetClick = _ref.onWebAssetClick;
  var content = data.contentItem;
  var isAsset = checkIsAsset(content);
  var contentItem = useCardController(_objectSpread(_objectSpread({}, data), {}, {
    onWebAssetClick: function onWebAssetClick() {
      return _onWebAssetClick({
        type: isAsset ? content.type : undefined,
        markAsDoneMode: isAsset ? content.markAsDoneMode : undefined,
        userContentStatus: content.userContentStatus,
        contentId: content.id
      });
    }
  }));
  return /*#__PURE__*/React.createElement(HorizontalCard, contentItem);
}
function Section(_ref2) {
  var section = _ref2.section,
    playlist = _ref2.playlist,
    nextContentItemIndex = _ref2.nextContentItemIndex,
    onWebAssetClick = _ref2.onWebAssetClick;
  var isEditablePlaylist = getIsPlaylistEditable({
    playlist: playlist
  });
  var contentItems = section.contentItems;
  var itemStack = /*#__PURE__*/React.createElement(Stack, {
    as: "ordered-list",
    spacing: ['m', 'l'],
    breakpoints: "s"
  }, contentItems.map(function (contentItem, i) {
    var itemIndex = section.startOffset + i;
    var pillKey;
    if (contentItem.goal) {
      pillKey = 'goal';
    } else if (nextContentItemIndex === itemIndex - 1) {
      pillKey = 'next';
    }
    var contentItemData = {
      contentItem: contentItem,
      index: itemIndex,
      priorityPillType: pillKey,
      collectionId: playlist.id,
      playlist: playlist,
      isEditablePlaylist: isEditablePlaylist,
      canSaveForLater: false,
      canEditPlaylist: true
    };
    return /*#__PURE__*/React.createElement(ControlledHorizontalCard, {
      key: contentItem.id,
      data: contentItemData,
      onWebAssetClick: onWebAssetClick
    });
  }));
  return section.data ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionBlock, {
    playlist: playlist,
    section: section.data
  }), itemStack) : itemStack;
}
export default Section;